import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Carousel } from "@/components/ui/carousel";
export default function Section365DaysOfUs() {
  return <section data-section-id="235981" id="built-for-north-carolina" className="w-full bg-background text-foreground">
      
    </section>;
}